import React from 'react';
import { _get } from 'core/utils/object-prop';
import { AppState } from 'core/redux/reducers';
import { selectTranslator } from 'core/redux/features/languages/trans';
import { connect } from 'react-redux';

const mapStateToProps = (state: AppState) => ({
  trans: selectTranslator(state),
});

const mapDispatchToProps = {};

interface OwnProps {
  field: string;
  errors: Record<string, string>;
}

type TProps = OwnProps &
  ReturnType<typeof mapStateToProps> &
  typeof mapDispatchToProps;

const ErrorMsgComp = (props: TProps) => {
  const msg = _get(props.errors, props.field, false);

  if (!msg) {
    return null;
  }

  return <span className="help is-danger">{props.trans(msg)}</span>;
};

const ErrorMsg = connect(mapStateToProps, mapDispatchToProps)(ErrorMsgComp);
export default ErrorMsg;
